<section role="tabpanel">
  <nav class="w-full flex overflow-x-auto  whitespace-nowrap" role="tablist" aria-label="Navegación de pestañas">
    @for (tab of tabs; track tab; let idx = $index) {
    <button
      (click)="selectTab(idx)"
      class="font-poppins px-4 py-3 text-sm focus:transition-colors duration-200"
      [ngClass]="{
        'bg-primary-g500 font-medium text-secundary-b1100 rounded-t-2xl':
          tab.active,
        'text-text-secondary font-normal hover:text-primary-g500': !tab.active
      }"
      role="tab"
      [attr.aria-selected]="tab.active"
      [attr.aria-controls]="'tabpanel-' + idx"
      [attr.id]="'tab-' + idx"
      [attr.tabindex]="tab.active ? 0 : -1"
    >
      {{ tab.label }}
    </button>
    }
  </nav>

  <hr class="flex-1 border-t-2 border-primary-g500" />

  <article
    role="tabpanel"
    [attr.aria-labelledby]="'tab-' + activeTabIndex"
    [attr.id]="'tabpanel-' + activeTabIndex"
  >
    <ng-content></ng-content>
  </article>
</section>
